export const TableHelpers = {
    data() {
        return {
            tableColumns: [
                {
                    title: 'Tipo',
                    type: 'custom-html',
                    key: 'evaluation_testification',
                    modifier: (item) => {
                        return item.type == 'E' ? 'Evaluacion' : 'Testificacion';
                    }
                },
                {
                    title: 'Evaluador',
                    type: 'custom-html',
                    key: 'evaluator',
                    modifier: (item) => {
                        return item.full_name;
                    }
                },
                {
                    title: 'OEC',
                    type: 'custom-html',
                    key: 'evaluation_testification',
                    modifier: (item) => {
                        return item.accreditation_applications.organization.name;
                    }
                },
                {
                    title: 'Codigo',
                    type: 'custom-html',
                    key: 'evaluation_testification',
                    modifier: (item) => {
                        return item.code;
                    }
                },
                {
                    title: 'Desde',
                    type: 'custom-html',
                    key: 'evaluation_testification',
                    modifier: (item) => {
                        return item.date_start;
                    }
                },
                {
                    title: 'Hasta',
                    type: 'custom-html',
                    key: 'evaluation_testification',
                    modifier: (item) => {
                        return item.date_end;
                    }
                },
                {
                    title: 'Asistencia',
                    type: 'custom-html',
                    key: 'is_confirmed',
                    modifier: (item) => {
                        return item == null
                            ? `<span class="badge badge-sm badge-pill badge-info">Pendiente</span>`
                            : item
                                ? `<span class="badge badge-sm badge-pill badge-success">SI</span>`
                                : `<span class="badge badge-sm badge-pill badge-danger">NO</span>`;
                    }
                },
            ],
            actionObj: {
                title: 'Acción',
                type: 'action',
            }
        }
    },
}